/**
 * System-made placeholder emails: `guest_…`, `missing-email-import-…` and `deleted_…` at @hopn.ca.
 * Nobody's inbox, never verifiable, and nothing a passenger should see as "their" email.
 *
 * Email ROWS (list-user-emails) carry `type: 'placeholder' | 'real'` — filter on that. This is for
 * the places that only hold a bare string (`user.email`, a trip's passenger contact), where the
 * address itself is all there is to go on.
 */
const PLACEHOLDER_EMAIL = /^(guest_|missing-email-import-|deleted_).*@hopn\.ca$/i

export const isPlaceholderEmail = (email) => PLACEHOLDER_EMAIL.test(String(email || '').trim())

/** The email to show: the address itself, or '' when it is only a placeholder. */
export const visibleEmail = (email) => (isPlaceholderEmail(email) ? '' : (email || ''))
